import StateManager from './StateManager'
import LayoutManager from './LayoutManager'
import $ from 'jquery'

/* -------------------------
    CONTENT READY LISTENER
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-scuba__nav')
    .scubaNav()
})

/* -------------------------
    JQ PLUGIN
------------------------- */

$.fn.scubaNav = function() {
  this.each(function(i, nav) {
    new Navigation(nav)
  })
}

/* --------------------------------------------------

    CONSTRUCTOR

-------------------------------------------------- */

function Navigation(nav) {
  this.$nav = $(nav).addClass('js-scuba__nav')

  // évite une double initialisation
  if (this.$nav.data('__scuba_navInitialized') === true) return
  this.$nav.data('__scuba_navInitialized', true)

  // récupère les liens de la navigation
  // this.$links = this.$nav.find('a');

  // récupère la page parente (ou header)
  this.$page = this.$nav.closest('.js-scuba__page, .js-scuba__head')
  this.pageUrl = !this.$page.is('.js-scuba__head')
    ? this.$page.data('url')
    : null

  // écouteurs
  this.$nav.on('itemsChanged', $.proxy(this.itemsChangedHandler, this))
  this.$page.on(
    StateManager.NEXT_PAGES_CHANGED,
    $.proxy(this._nextPagesChangedHandler, this)
  )

  this.$nav.on(
    'click',
    '.js-scuba__menu__prev-link',
    $.proxy(this.prevMenulinkClickHandler, this)
  )
}

/* --------------------------------------------------

    METHODS

-------------------------------------------------- */

Navigation.prototype._nextPagesChangedHandler = function(event, pages) {
  /*var $activeLinks;*/

  this.nextPages = pages

  this.updateSelection()
}

Navigation.prototype.prevMenulinkClickHandler = function(event) {
  const layout = LayoutManager.getAvailableLayout()
  if (layout) {
    if (layout.name === 'MobileLayout') {
      layout.mhead._backClickHandler(event)
    } else if (layout.name === 'HorizontalLayout') {
      layout.arrows._menuPreviousClickHandler(event)
    }
  }
}

Navigation.prototype.updateSelection = function() {
  var $activeLinks,
    $links = this.$nav.find('a')
  $.each(
    this.nextPages,
    $.proxy(function(i, page) {
      $activeLinks = $links.filter(function() {
        var cleanHref = $(this).attr('href')

        if (!cleanHref) {
          return false
        }

        cleanHref = cleanHref.replace(location.origin, '').replace(/\?.*/, '')
        return cleanHref === page.url.replace(/\?.*/, '')
      })

      if ($activeLinks.length > 0) {
        $activeLinks.addClass('is-active')
        return false // équivalent de break
      } else {
        $activeLinks = null
      }
    }, this)
  )

  $links.not($activeLinks).removeClass('is-active')
  $activeLinks && this.bubbleSelection($activeLinks)
}

Navigation.prototype.bubbleSelection = function($activeLink) {
  var $ul = $activeLink.closest('ul')

  // sélectionne le lien situé à côté du ul parent
  var $parentLink = $ul.prev('a')
  if ($parentLink.length > 0) {
    $parentLink.addClass('is-active')
    this.bubbleSelection($parentLink)
  }
}



// WEBPACK FOOTER //
// ./scripts/scuba/Navigation.js